import { Component, OnInit } from '@angular/core';
import { MouvementsProduitsService } from 'src/app/data/declaration/services/mouvements/mouvements-produits.service';
import { HistoriqueMouvement } from 'src/app/data/declaration/models/historique-mouvement.model';
import { SessionContext, NavigationContext } from 'src/app/core/services/config/app.settings';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { map, switchMap } from 'rxjs/operators';
import * as moment from 'moment';
import { ReferentielService } from 'src/app/data/declaration/services/referentiel/referentiel.service';
import { Referentiel } from 'src/app/data/declaration/models/referentiel.model';
import { RefMouvement } from 'src/app/data/declaration/models/ref-mouvement.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VueTransactionComponent } from '../../../suivi-declarations/modal/vue-transaction/vue-transaction.component';
import { VueChangementDenominationComponent } from '../../../suivi-declarations/modal/vue-changement-denomination/vue-changement-denomination.component';
import { VueConditionnementComponent } from '../../../suivi-declarations/modal/vue-conditionnement/vue-conditionnement.component';
import { VueTirageComponent } from '../../../suivi-declarations/modal/vue-tirage/vue-tirage.component';
import { VueRevendicationComponent } from '../../../suivi-declarations/modal/vue-revendication/vue-revendication.component';
import { TelechargerDocumentComponent } from '../../../main/components/telecharger-document/telecharger-document.component';
import { CategorieEnum } from 'src/app/data/edition/models/enums/categorie.enum.model';
import { CahiersService } from '../../../../../data/habilitation/services/cahiers/cahiers.service';
import { Cahier } from '../../../../../data/habilitation/models/cahier.model';
import { ControlesService } from '../../../../../data/declaration/services/controles/controles.service';
import { Controle } from '../../../../../data/declaration/models/controle.model';
import { EtatHistoriqueMouvementEnum } from '../../../../../data/declaration/models/enums/etat-historique-mouvement.enum';
import { forkJoin, of } from 'rxjs';
import { EchantillonsService } from '../../../../../data/declaration/services/echantillons/echantillons.service';
import { Echantillon } from '../../../../../data/declaration/models/echantillon.model';
import { Manquement } from '../../../../../data/declaration/models/manquement.model';
import { ManquementsService } from '../../../../../data/declaration/services/manquements/manquements.service';
import { LoaderService } from '../../../../../core/services/loader/loader.service';

@Component({
    selector: 'app-historique',
    templateUrl: './historique.component.html',
    styleUrls: ['./historique.component.scss'],
    standalone: false
})
export class HistoriqueComponent implements OnInit {
    /**
     * Tous les mouvements historiques
     */
    public historiques: HistoriqueMouvement[] = [];

    /**
     * Historiques mouvements affichés
     */
    public displayedHistoriques: HistoriqueMouvement[] = [];

    /**
     * Tous les controles associés aux mouvements historiques
     */
    public controles: Controle[] = [];

    /**
     * Tous les échantillons associés aux mouvements historiques
     */
    public echantillons: Echantillon[] = [];

    /**
     * Tous les manquements associés aux controles
     */
    public manquements: Manquement[] = [];

    /**
     * Tous les référentiels
     */
    public referentiel: Referentiel;

    /**
     * L'id de l'organisme connecté
     */
    public idOrganisme: number;

    /**
     * Tous les cahiers des charges associés à l'organisme connecté
     */
    public cahiers: Cahier[];

    /**
     * Getter de l'id opérateur
     */
    get idOperateur() {
        return NavigationContext.has('idOperateur') ? NavigationContext.get('idOperateur') : SessionContext.get('idIntervenant');
    }

    /**
     * Formulaire de recherche
     */
    public formRecherche: UntypedFormGroup;

    /**
     * Getter millésime
     */
    get millesime() {
        return this.formRecherche.get('millesime');
    }

    /**
     * Getter année de déclaration
     */
    get anneeDeclaration() {
        return this.formRecherche.get('anneeDeclaration');
    }

    /**
     * Getter cahier des charges
     */
    get cdc() {
        return this.formRecherche.get('cdc');
    }

    /**
     * Getter type de déclaration
     */
    get typeDeclatation() {
        return this.formRecherche.get('typeDeclatation');
    }

    /**
     * True if has a result
     */
    hasResult = false;

    /**
     * Colonnes dynamiques
     */
    columns = [
        { field: 'dateDebut', label: 'page.declarations.historique-mouvements.table.header.dateDebut' },
        { field: 'typeDeclaration', label: 'page.declarations.historique-mouvements.table.header.typeDeclaration' },
        { field: 'annee', label: 'page.declarations.historique-mouvements.table.header.annee' },
        { field: 'produit', label: 'page.declarations.historique-mouvements.table.header.produit' },
        { field: 'volumeTotal', label: 'page.declarations.historique-mouvements.table.header.volumeTotal' },
        { field: 'dateMouvement', label: 'page.declarations.historique-mouvements.table.header.dateMouvement' },
        { field: 'etat', label: 'page.declarations.historique-mouvements.table.header.etat' },
        { field: 'logementLot', label: 'page.declarations.historique-mouvements.table.header.logementLot' },
        { field: 'numeroDossier', label: 'page.declarations.historique-mouvements.table.header.numeroDossier' }
    ];

    constructor(
        private readonly mouvementsProduitsService: MouvementsProduitsService,
        private readonly referentielService: ReferentielService,
        private readonly loaderService: LoaderService,
        private readonly fb: UntypedFormBuilder,
        private readonly modalService: NgbModal,
        private readonly cahierService: CahiersService,
        private readonly controlesService: ControlesService,
        private readonly echantillonsService: EchantillonsService,
        private readonly manquementsService: ManquementsService
    ) {
        this.idOrganisme = SessionContext.get('idOrganisme');
    }

    ngOnInit() {
        // Initialiser le formulaire de recherche avancée
        this.formRecherche = this.fb.group({
            millesime: [undefined, [Validators.pattern(/(19|20)\d\d/)]],
            anneeDeclaration: [undefined, [Validators.pattern(/(19|20)\d\d/)]],
            numeroLot: undefined,
            debut: undefined,
            fin: undefined,
            cdc: undefined,
            produit: undefined,
            typeDeclatation: undefined,
            numeroDossier: undefined
        });

        // Récupère tous les historiques de mouvement en fonction de l'opérateur
        // Et récupère la liste des controles en fonction d'une liste de mouvement ids
        // Et récupère la liste des échantillons en fonction d'une liste de mouvement ids
        // Et récupère la liste des manquements en fonction d'une liste de controle ids
        this.mouvementsProduitsService
            .getAllHistoriqueMouvement(this.idOperateur)
            .pipe(
                switchMap(historiques => {
                    const mouvementIds = historiques.map(h => h.idMouvement);
                    return forkJoin([
                        of(historiques),
                        this.controlesService.getControlesByIdsMouvement(mouvementIds),
                        this.echantillonsService.getEchantillonsByIdsMouvement(mouvementIds)
                    ]);
                }),
                switchMap(([historiques, controles, echantillons]) => {
                    this.controles = controles;
                    this.echantillons = echantillons;
                    const controleIds = controles.map(c => c.id);
                    return forkJoin([of(historiques), this.manquementsService.getManquementsByIdsControle(controleIds)]);
                }),
                map(([historiques, manquements]) => {
                    this.manquements = manquements;
                    return historiques.sort((a, b) => new Date(b.dateDebut).getTime() - new Date(a.dateDebut).getTime());
                }),
                this.loaderService.operator()
            )
            .subscribe(sortedHistoriques => {
                this.hasResult = true;
                this.historiques = sortedHistoriques;
                this.displayedHistoriques = sortedHistoriques;
            });

        // Récupère les cahiers des charges en fonction de l'organisme connecté
        this.cahierService.getCahiersByOrganisme(this.idOrganisme).subscribe(cahiers => {
            this.cahiers = cahiers.sort((a, b) => a.libelle.localeCompare(b.libelle));
        });

        // Charger le référentiel pour obtenir les types de mouvements
        this.referentielService.getReferentiel().subscribe(referentiel => {
            this.referentiel = referentiel;
            this.referentiel.refMouvements = referentiel.refMouvements.sort((a, b) => a.libelle.localeCompare(b.libelle));
        });
    }

    /**
     * Applique les filtres
     */
    onSubmit() {
        this.filtrer();
    }

    /**
     * Filtre la liste des historiques avec les données entrées
     * dans le formulaire de recherche avancée
     */
    public filtrer(): void {
        if (this.anneeDeclaration.value || this.millesime.value || this.cdc.value || this.typeDeclatation.value) {
            this.displayedHistoriques = this.historiques.filter(historique => {
                let result = true;
                if (this.anneeDeclaration.value && this.anneeDeclaration.invalid) {
                    result = false;
                }
                if (
                    this.anneeDeclaration.value &&
                    this.anneeDeclaration.valid &&
                    parseInt(this.anneeDeclaration.value, 10) !== moment(historique.dateDebut).year()
                ) {
                    result = false;
                }
                if (this.millesime.value && this.millesime.invalid) {
                    result = false;
                }
                if (this.millesime.value && this.millesime.valid && +this.millesime.value !== historique.annee) {
                    result = false;
                }
                if (this.cdc.value && this.cdc.value.length > 0) {
                    const codes = this.cdc.value.map(c => c.libelle.toLowerCase());
                    if (!codes.includes(historique.libelleCahier.toLowerCase())) {
                        result = false;
                    }
                }
                if (this.typeDeclatation.value && this.typeDeclatation.value.length > 0) {
                    const codes = this.typeDeclatation.value.map(d => d.code);
                    if (!codes.includes(historique.code)) {
                        result = false;
                    }
                }
                return result;
            });
        } else {
            this.displayedHistoriques = this.historiques;
        }
    }

    /**
     * Get type de déclaration
     * @param code - Code
     */
    public getTypeMouvement(code: string): string {
        let libelle = '';

        if (this.referentiel && this.referentiel.refMouvements) {
            const mouvement: RefMouvement = this.referentiel.refMouvements.find(mvt => mvt.code === code);
            if (mouvement) {
                libelle = mouvement.libelle;
            }
        }

        return libelle;
    }

    /**
     * On edit
     * @param mouvement - Mouvement à modifier
     */
    public onEdit(mouvement: HistoriqueMouvement): void {
        let obj;

        switch (mouvement.code) {
            case 'TRANSACTION':
                obj = VueTransactionComponent;
                break;
            case 'CHANGEMENT_DENOMINATION':
                obj = VueChangementDenominationComponent;
                break;
            case 'CONDITIONNEMENT':
                obj = VueConditionnementComponent;
                break;
            case 'TIRAGE':
                obj = VueTirageComponent;
                break;
            case 'REVENDICATION':
                obj = VueRevendicationComponent;
                break;
        }

        const modalCd = this.modalService.open(obj, { backdrop: 'static', windowClass: 'app-modal-60' });
        modalCd.componentInstance.idMouvement = mouvement.idMouvement;
        modalCd.componentInstance.idOperateur = this.idOperateur;
    }

    /**
     * Télécharger document
     * @param mouvement - Mouvement associé
     */
    public telechargerDocument(mouvement: HistoriqueMouvement) {
        const modalRef = this.modalService.open(TelechargerDocumentComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.declaration = mouvement;
        modalRef.componentInstance.categorie = CategorieEnum.DECLARATION;
        modalRef.componentInstance.idOrganisme = mouvement.idOrganisme;
        modalRef.result.then(error => {
            throw error;
        });
    }

    /**
     * Get état d'un lot
     * @param mouvement - Mouvement associé
     */
    getEtat(mouvement: HistoriqueMouvement): string {
        // 1. Cas immédiat : non contrôlable
        if (mouvement.nonControlable) {
            return EtatHistoriqueMouvementEnum.NON_CONTROLE;
        }

        // 2. Contrôle associé au mouvement (si existe ?)
        const controleAssocie = this.controles.find(c => c.idMouvement === mouvement.idMouvement);

        // Pas de contrôle → "Déclaré"
        if (!controleAssocie) {
            return EtatHistoriqueMouvementEnum.DECLARE;
        }

        // 3. Résultat du contrôle (Terminé ?)
        const statutControleTermine = this.referentiel.statutsControle.find(s => s.code === 'TERMINE');
        const hasResultControle = controleAssocie && controleAssocie.idStatut === statutControleTermine.id;

        // 4. Si controle pas terminé → vérifier les échantillons
        if (!hasResultControle) {
            const statutEchantillonAPrelever = this.referentiel.echantillonStatuts.find(s => s.code === 'A_PRELEVER');
            const hasEchantillonAPrelever = this.echantillons.some(
                e => e.id === controleAssocie.idEchantillon && e.idStatutEchantillon === statutEchantillonAPrelever.id
            );
            return hasEchantillonAPrelever ? EtatHistoriqueMouvementEnum.EN_PRELEVEMENT : EtatHistoriqueMouvementEnum.PRELEVE;
        }

        // 5. Contrôle terminé → vérifier manquements
        const manquementAssocie = this.manquements.find(m => m.idControle === controleAssocie.id);

        // Pas de manquement → Conforme immédiat
        if (!manquementAssocie) {
            return EtatHistoriqueMouvementEnum.CONFORME;
        }

        // 6. Si manquement (Non conforme ?)
        const statutsManquementConformes = this.referentiel?.statutsManquement.filter(s => s.code === 'LEVE' || s.code === 'ANNULE').map(s => s.id);
        return statutsManquementConformes.includes(manquementAssocie.idStatut)
            ? EtatHistoriqueMouvementEnum.CONFORME
            : EtatHistoriqueMouvementEnum.NON_CONFORME;
    }
}
